import React from 'react';

import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

const withRouter = Component => {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams] = useSearchParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, match: { params, searchParams } }}
      />
    );
  }

  return ComponentWithRouterProp;
};

export default withRouter;
